import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from '../api';

const SignUp = ({ setIsLogIn, setUserData, setToken }) => {
    const emailRef = useRef();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        emailRef.current.focus();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            return toast.error('Please fill out all the fields');
        }

        const response = await apiCall('POST', '/signup', {email, password, passwordAgain});

        if (response?.status === 401 || response?.status === 400) {
            return toast.error(response.message);
        } else if (response?.status === 201) {
            const user = {
                user: response.user,
                token: response.token
            }
            setUserData(user);
            setToken(response.token);

            return navigate('/dashboard');
        } else {
            toast.error('Sign Up Failed');
        }
    }
    
    return (
        <div className="login">
            <form className="login__form" onSubmit={handleSubmit}>
                <input
                    ref={emailRef}
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    />
                <input
                    type="password"
                    placeholder="Password Again"
                    value={passwordAgain}
                    onChange={(e) => setPasswordAgain(e.target.value)}
                    />
                <button
                    type="submit"
                    className="submit__btn" >Sign Up</button>
                <div
                    className="signup__link">Already a member? <div onClick={() => setIsLogIn(true)}>Login</div></div>
            </form>
            <Toaster />
        </div>
    )
}

export default SignUp;
